<template>
  <div class="h-100 p-5">
    <h3>{{ customer }}</h3>
    <DataTable class="mt-3" :data="tableData" noSearch>
      <template #head>
        <tr>
          <Th prop="productName" sort>PO #</Th>
          <Th class="w-100" prop="orderDate" sort>Product Name</Th>
          <Th>Status</Th>
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>{{ item.orderId }}</td>
          <td>{{ item.productName }}</td>
          <td>
            <ITMCustomerStatusChart class="status-chart" :deliveries="item.deliveries" @mousewheel.stop.prevent @scroll.stop.prevent />
          </td>
        </tr>
      </template>
    </DataTable>

    <Loader v-if="isLoading" />
  </div>
</template>

<script>
import axios from '../../axios';
import DataTable from '../../components/common/dataTable/DataTable.vue';
import Loader from '../../components/common/loader/Loader.vue';
import { errorDebug } from '../../libraries/common';
import ITMCustomerStatusChart from './ITMCustomerStatusChart.vue';
export default {
  components: { Loader, DataTable, ITMCustomerStatusChart, },
  data() {
    return {
      customer: null,
      orders: null,
      isLoading: false,
    };
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
    tableData() {
      return (this.orders || [])
        .flatMap(this.allInfo);
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      axios.get(`/api/ITM/CustomerAccess/${this.token}`, {
        headers: {
          'customer-authentication': sessionStorage.getItem('customerToken'),
        }
      })
        .then(({ data }) => {
          this.customer = data.customer;
          this.orders = data.orders;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$router.replace({ name: 'itmCustomerAccessNotFound' })
          } else if (err.response.status === 401) {
            this.$router.push({ name: 'itmCustomerAccessLogIn', params: { token: this.token } })
          } else {
            errorDebug(err);
          }
        })
        .then(() => this.isLoading = false);
    },
    allInfo(item) {
      var a = item.products
        .flatMap((product, productInd) => {
          return product.orderDeliveries
            .map((h, orderInd) => ({
              orderId: !productInd ? item.orderId : null,
              productName: !orderInd ? product.productName : null,
              deliveries: h,
              status: h.last().status,
            }))
        });
      return a;
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMCustomerAccess'] = this;
    this.getData();
  },
}
</script>

<style lang="scss" scoped>
.status-chart {
  width: 800px;
}
</style>